import * as React from "react";
import { Row, Col, Checkbox, Icon, Tooltip } from "antd";
import styled from "styled-components";
import { ExtraType } from "../lib/model/ExtraType";
import { displayStringForExtraType } from "../lib/formatters";

const options = [
  { value: ExtraType.Liftgate },
  { value: ExtraType.RigidBox },
  { value: ExtraType.Sideloading },
  {
    value: ExtraType.RampLoadable,
    info:
      "Rampenfähige Fahrzeuge verfügen über eine Ladehöhe von mind. 1,2m und ein zGG von mind. 7,5t."
  },
  { value: ExtraType.Forklift },
  {
    value: ExtraType.NeutralVehicle,
    info:
      "Fahrzeuge können mit Namen und Zeichen des Transporteurs versehen sein, nicht jedoch mit Folierung eines 3PL."
  },
  { value: ExtraType.PalletExchange },
  { value: ExtraType.TwoManHandling }
];

const StyledCheckbox = styled(Checkbox)`
  input[type="checkbox"] {
    background-color: #dedede;
  }
  font-size: 11px !important;
  line-height: 32px !important;
  color: #061a32 !important;
  font-weight: 300 !important;
`;

type Props = {
  activeValues?: ExtraType[];
  onChange?: (activeValues: ExtraType[]) => void;
};

export class ExtrasPicker extends React.Component<Props> {
  render() {
    const { onChange, activeValues } = this.props;
    return (
      <Row type="flex">
        {options.map(o => (
          <Col span={12} key={o.value}>
            <StyledCheckbox
              checked={(activeValues || []).indexOf(o.value) !== -1}
              onChange={() => {
                if (onChange) {
                  onChange(toggleMember(activeValues || [], o.value));
                }
              }}
            >
              {displayStringForExtraType(o.value)}
              {!!o.info && (
                <Tooltip title={o.info}>
                  {" "}
                  <Icon type="info-circle" />
                </Tooltip>
              )}
            </StyledCheckbox>
          </Col>
        ))}
      </Row>
    );
  }
}

function toggleMember<T>(a: Array<T>, v: T): Array<T> {
  if (a.indexOf(v) !== -1) {
    const r = [...a];
    r.splice(a.indexOf(v), 1);
    return r;
  } else {
    return [...a, v];
  }
}
